import React from 'react';
import {useFormContext} from 'react-hook-form';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {PASSWORD_REQUIREMENTS} from 'presentation/constants';
import {usePasswordRequirements} from 'presentation/pages/public/hooks';
import {translations} from 'presentation/translations-new';
import {IFormData} from 'presentation/pages/public/sign-up/components/Forms/Step4/schema';
import {PasswordRequirementItem} from './PasswordRequirementItem';

const {title} = translations['pt-br'].publicFlow.passwordRequirements;

export function PasswordRequirementsList() {
	const {getFieldState} = useFormContext<IFormData>();
	const {validation} = usePasswordRequirements();
	const {isDirty} = getFieldState('password');

	return (
		<Stack gap={1}>
			<Typography variant="body2">{title}</Typography>

			<PasswordRequirementItem
				isDirty={isDirty}
				isValid={!validation?.includes(PASSWORD_REQUIREMENTS.EXACT_LENGTH)}
				msg={PASSWORD_REQUIREMENTS.EXACT_LENGTH}
			/>
			<PasswordRequirementItem
				isDirty={isDirty}
				isValid={!validation?.includes(PASSWORD_REQUIREMENTS.HAS_UPPERCASE)}
				msg={PASSWORD_REQUIREMENTS.HAS_UPPERCASE}
			/>
			<PasswordRequirementItem
				isDirty={isDirty}
				isValid={!validation?.includes(PASSWORD_REQUIREMENTS.HAS_LOWERCASE)}
				msg={PASSWORD_REQUIREMENTS.HAS_LOWERCASE}
			/>
			<PasswordRequirementItem
				isDirty={isDirty}
				isValid={!validation?.includes(PASSWORD_REQUIREMENTS.HAS_NUMBER)}
				msg={PASSWORD_REQUIREMENTS.HAS_NUMBER}
			/>
			<PasswordRequirementItem
				isDirty={isDirty}
				isValid={!validation?.includes(PASSWORD_REQUIREMENTS.HAS_SPECIAL_CHAR)}
				msg={PASSWORD_REQUIREMENTS.HAS_SPECIAL_CHAR}
			/>
		</Stack>
	);
}
